import { create } from 'zustand';
import axios from 'axios';

// The logged-in user, fetched once and shared. Login already calls
// /api/users/me but discards the result, so before this store every screen that
// wanted the current user either re-fetched it or — as the P&L and Ledger
// screens did — rendered a hardcoded "Current User" placeholder.
//
// Note: the users table has only id/email/is_active. There is no name column,
// so `email` is the only human-readable identifier available to display.

export interface CurrentUser {
  id: number;
  email: string;
  is_active: boolean;
}

export interface CurrentUserStore {
  user: CurrentUser | null;
  isLoading: boolean;
  fetchCurrentUser: () => Promise<void>;
  clearCurrentUser: () => void;
}

export const useCurrentUser = create<CurrentUserStore>((set, get) => ({
  user: null,
  isLoading: false,

  fetchCurrentUser: async () => {
    // Already loaded or in flight — don't refetch on every screen mount.
    if (get().user || get().isLoading) return;
    const token = localStorage.getItem('accessToken');
    if (!token) return;

    set({ isLoading: true });
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/users/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      set({ user: res.data, isLoading: false });
    } catch (err) {
      console.error('Failed to fetch current user', err);
      set({ isLoading: false });
    }
  },

  clearCurrentUser: () => set({ user: null, isLoading: false }),
}));
